var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSns3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1575 -3569)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 10",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1575 3569)",
    style: {
      fill: "#303542"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 25",
    d: "M6 29v14.652c0 .278.163.505.363.505h2.9c.2 0 .363-.227.363-.505V29",
    transform: "translate(1585.813 3554.843)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 26",
    d: "M2.813 19h-1.45a.355.355 0 0 0-.363.345V22.1a.355.355 0 0 0 .363.345h1.45",
    transform: "translate(1589 3566.207)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 27",
    d: "M16 22.448h2.538a.457.457 0 0 0 .434-.338l.583-2.772a.276.276 0 0 0-.292-.338H16",
    transform: "translate(1579.438 3566.207)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 28",
    d: "M16.047 1H18.9v3.448h-2.538L16 4.793v2.414",
    transform: "translate(1579.439 3578)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 8",
    transform: "translate(1591.813 3582.478)",
    style: {
      fill: "none"
    },
    d: "M0 2.729.016 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 29",
    d: "M6.043 4.478A3.3 3.3 0 0 1 9.7 1v6.988H6.043z",
    transform: "translate(1585.785 3578)",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSns3);
export default __webpack_public_path__ + "static/media/sns_3.8ea12b2912359464086321b8d123643f.svg";
export { ForwardRef as ReactComponent };